module.exports = __webpack_public_path__ + "img/banner-policy-text.6711646d.png";